import { ETripType } from '../../common/types';
import { ICartTrips } from './types';

export const DEFAULT_CART_TRIPS: ICartTrips = {
  [ETripType.OUTBOUND]: null,
  [ETripType.RETURN]: null,
};
